module.exports = __webpack_public_path__ + "static/media/lakecarolina-background-4.1bcdfef9.jpg";